<p>pgn-layer-edit works!</p>
